import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Events } from 'ionic-angular';
import { ImyBookHighlight } from '../../../models/myBookHighlight';
//import { Highlight } from '../../../providers/books-service';


@Component({
  selector: 'page-highlights',
  templateUrl: 'highlights.html'
})
export class Highlights {
  highlights: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, private alertController: AlertController) {
    this.highlights = navParams.data;
  }

  select(highlight: ImyBookHighlight) {
    const confirm = this.alertController.create({
      title: 'Evidenziazione',
      message: highlight.text,
      buttons: [
        {
          text: "chiudi",
          role: "cancel",
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: "Vai",
          handler: data => {
            this.events.publish('select:location', highlight.location);
            this.events.publish('booksDetailsModalShow', false);
          }
        }

      ]
    });
    confirm.present();
  }


  delete(highlight: ImyBookHighlight) {
    const confirm = this.alertController.create({
      title: 'Conferma',
      message: " Vuoi eliminare questa evidenziazione?",
      buttons: [
        {
          text: "annulla",
          role: "cancel",
          cssClass: 'icon-color',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: "Elimina",
          cssClass: 'icon-delete',
          handler: data => {
            let index = this.highlights.map(highlights => highlights.cfiRange).indexOf(highlight.cfiRange);
            this.highlights.splice(index, 1);
            this.events.publish('delete:highlight',highlight)
          }
        }
      ]
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/BOOK-READER/highlights/highlights.ts